export default __webpack_public_path__ + "static/media/2010.98159e4c.png";